import { render, staticRenderFns } from "./gewinne-modal.vue?vue&type=template&id=463e73b8&"
import script from "./gewinne-modal.vue?vue&type=script&lang=js&"
export * from "./gewinne-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports